import { Component, OnInit, inject } from '@angular/core';
import {ReactiveFormsModule, UntypedFormBuilder, UntypedFormGroup, Validators} from "@angular/forms";
import {ActivatedRoute, Router} from "@angular/router";
import {DataService} from "../../services/data.service";
import {AccessService} from "../../services/access.service";
import {ToastrService} from "ngx-toastr";
import Swal from "sweetalert2";
import {ViewMode} from "../../interfaces";
import {NgIf} from "@angular/common";
import {YesNoPipe} from "../../pipes/yes-no.pipe";
import {ApiPipe} from "../../pipes/api.pipe";

@Component({
    selector: 'app-supplier-detail',
    imports: [NgIf, ReactiveFormsModule, YesNoPipe, ApiPipe],
    template: `
        <div class="card">
            <div class="card-body">
                <div class="mb-4">
                    <h3>
                        <i class="fa-solid fa-boxes-packing me-2"></i>
                        @switch (viewMode) {
                            @case (ViewMode.INSERT) {
                                Lieferant anlegen
                            }
                            @case (ViewMode.EDIT) {
                                Lieferant bearbeiten
                            }
                            @case (ViewMode.VIEW) {
                                Lieferant
                            }
                        }
                    </h3>
                </div>

                <form [formGroup]="form">
                    <h5>Firma</h5>
                    <div class="row g-3 align-items-end mb-3">
                        <div class="col-12 col-lg-4">
                            <label>Firmenname</label>
                            <input type="text" class="form-control" formControlName="name" *ngIf="viewMode != ViewMode.VIEW">
                            <p *ngIf="viewMode == ViewMode.VIEW" class="mb-0">{{ form.value.name }}</p>
                        </div>
                    </div>

                    <h5>Kontakt</h5>
                    <div class="row g-3 align-items-end mb-3">
                        <div class="col-12 col-lg-4">
                            <label>Ansprechperson Stammdaten</label>
                            <input type="text" class="form-control" formControlName="name_masterdata" *ngIf="viewMode != ViewMode.VIEW">
                            <p *ngIf="viewMode == ViewMode.VIEW" class="mb-0">{{ form.value.name_masterdata }}</p>
                        </div>
                        <div class="col-6 col-lg-4">
                            <label>E-Mail Stammdaten</label>
                            <input type="text" class="form-control" formControlName="email_masterdata" *ngIf="viewMode != ViewMode.VIEW">
                            <p *ngIf="viewMode == ViewMode.VIEW" class="mb-0">
                                @if (form.value.email_masterdata) { <a (click)="$event.stopPropagation()" [href]="'mailto:' + form.value.email_email_masterdata">{{ form.value.email_masterdata }}</a> }
                                <span class="text-muted" *ngIf="!form.value.email_masterdata">Nicht gesetzt</span>
                            </p>
                        </div>
                    </div>
                    <div class="row g-3 align-items-end mb-3">
                        <div class="col-12 col-lg-4">
                            <label>Ansprechperson Bestellung</label>
                            <input type="text" class="form-control" formControlName="name_order" *ngIf="viewMode != ViewMode.VIEW">
                            <p *ngIf="viewMode == ViewMode.VIEW" class="mb-0">{{ form.value.name_order }}</p>
                        </div>
                        <div class="col-6 col-lg-4">
                            <label>E-Mail Bestellung</label>
                            <input type="text" class="form-control" formControlName="email_order" *ngIf="viewMode != ViewMode.VIEW">
                            <p *ngIf="viewMode == ViewMode.VIEW" class="mb-0">
                                @if (form.value.email_order) { <a (click)="$event.stopPropagation()" [href]="'mailto:' + form.value.email_order">{{ form.value.email_order }}</a> }
                                <span class="text-muted" *ngIf="!form.value.email_order">Nicht gesetzt</span>
                            </p>
                        </div>
                    </div>

                    <h5>Adresse</h5>
                    <div class="row g-3 align-items-end mb-3">
                        <div class="col-6 col-lg-2">
                            <label>PLZ</label>
                            <input type="text" class="form-control" formControlName="zip" *ngIf="viewMode != ViewMode.VIEW">
                            <p *ngIf="viewMode == ViewMode.VIEW" class="mb-0">{{ form.value.zip }}</p>
                        </div>
                        <div class="col-6 col-lg-3">
                            <label>Ort</label>
                            <input type="text" class="form-control" formControlName="city" *ngIf="viewMode != ViewMode.VIEW">
                            <p *ngIf="viewMode == ViewMode.VIEW" class="mb-0">{{ form.value.city }}</p>
                        </div>
                        <div class="col-12 col-lg-3">
                            <label>Straße</label>
                            <input type="text" class="form-control" formControlName="street" *ngIf="viewMode != ViewMode.VIEW">
                            <p *ngIf="viewMode == ViewMode.VIEW" class="mb-0">{{ form.value.street }}</p>
                        </div>
                    </div>

                    <h5>Rechtliches & Steuern</h5>
                    <div class="row g-3 align-items-end mb-3">
                        <div class="col-12 col-lg-4">
                            <label>Firmenbuchnummer</label>
                            <input type="text" class="form-control" formControlName="register_number" *ngIf="viewMode != ViewMode.VIEW">
                            <p *ngIf="viewMode == ViewMode.VIEW" class="mb-0">{{ form.value.register_number }}</p>
                        </div>
                        <div class="col-12 col-lg-4">
                            <label>UID</label>
                            <input type="text" class="form-control" formControlName="vat_number" *ngIf="viewMode != ViewMode.VIEW">
                            <p *ngIf="viewMode == ViewMode.VIEW" class="mb-0">{{ form.value.vat_number }}</p>
                        </div>
                    </div>

                    <h5>Bankdaten</h5>
                    <div class="row g-3 align-items-end mb-3">
                        <div class="col-12 col-lg-4">
                            <label>IBAN</label>
                            <input type="text" class="form-control" formControlName="iban" *ngIf="viewMode != ViewMode.VIEW">
                            <p *ngIf="viewMode == ViewMode.VIEW" class="mb-0">{{ form.value.iban }}</p>
                        </div>
                        <div class="col-12 col-lg-4">
                            <label>BIC</label>
                            <input type="text" class="form-control" formControlName="bic" *ngIf="viewMode != ViewMode.VIEW">
                            <p *ngIf="viewMode == ViewMode.VIEW" class="mb-0">{{ form.value.bic }}</p>
                        </div>
                    </div>

                    <h5>Diverses</h5>
                    <div class="row g-3 align-items-end mb-3">
                        <div class="col-12 col-lg-4">
                            <label>Sondertext</label>
                            <textarea class="form-control" formControlName="special_text" *ngIf="viewMode != ViewMode.VIEW"></textarea>
                            <p *ngIf="viewMode == ViewMode.VIEW" class="mb-0">
                                {{ form.value.special_text }}
                                <span class="text-muted" *ngIf="!form.value.special_text">Nicht gesetzt</span>
                            </p>
                        </div>
                        <div class="col-12 col-lg-4">
                            <label>Schnittstelle</label>
                            <select class="form-select" formControlName="api" *ngIf="viewMode != ViewMode.VIEW">
                                <option [ngValue]="null">Bitte wählen</option>
                                <option value="mail">E-Mail</option>
                            </select>
                            <p *ngIf="viewMode == ViewMode.VIEW" class="mb-0">{{ form.value.api | api }}</p>
                        </div>
                        <div class="col-12 col-lg-4">
                            <label>Aktiv</label>
                            <div *ngIf="viewMode != ViewMode.VIEW">
                                <input type="checkbox" class="form-check-input" formControlName="active">
                            </div>
                            <p *ngIf="viewMode == ViewMode.VIEW" class="mb-0">{{ form.value.active | yesNo }}</p>
                        </div>

                    </div>

                    <h5>Bestellung</h5>
                    <div class="row g-3 align-items-end">
                        <div class="col-12 col-lg-4">
                            <label>Preise anzeigen</label>
                            <div *ngIf="viewMode != ViewMode.VIEW">
                                <input type="checkbox" class="form-check-input" formControlName="order_show_prices">
                            </div>
                            <p *ngIf="viewMode == ViewMode.VIEW" class="mb-0">{{ form.value.order_show_prices | yesNo }}</p>
                        </div>
                        <div class="col-12 col-lg-4">
                            <label>Auswahl Lieferuhrzeit</label>
                            <div *ngIf="viewMode != ViewMode.VIEW">
                                <input type="checkbox" class="form-check-input" formControlName="order_allow_time">
                            </div>
                            <p *ngIf="viewMode == ViewMode.VIEW" class="mb-0">{{ form.value.order_allow_time | yesNo }}</p>
                        </div>
                    </div>
                </form>

                <div class="mt-3 d-flex flex-wrap justify-content-between gap-2">
                    @if (viewMode == ViewMode.VIEW) {
                        <div class="d-flex flex-wrap gap-2">
                            <button type="button" class="btn btn-primary" (click)="setMode(ViewMode.EDIT)">Bearbeiten</button>
                            <button type="button" class="btn btn-secondary" (click)="cancel()">Zurück</button>
                            <button type="button" class="btn btn-danger" (click)="delete()">Löschen</button>
                        </div>
                    } @else if (viewMode == ViewMode.EDIT) {
                        <div class="d-flex flex-wrap gap-2">
                            <button type="button" class="btn btn-primary" [disabled]="form.invalid" (click)="update()">Aktualisieren</button>
                            <button type="button" class="btn btn-secondary" (click)="cancelEdit()">Abbrechen</button>
                        </div>
                    } @else if (viewMode == ViewMode.INSERT) {
                        <div class="d-flex flex-wrap gap-2">
                            <button type="button" class="btn btn-primary" [disabled]="form.invalid" (click)="save()">Speichern</button>
                            <button type="button" class="btn btn-secondary" (click)="cancel()">Abbrechen</button>
                        </div>
                    }
                </div>

            </div>
        </div>
    `
})
export class SupplierDetailComponent implements OnInit {

    accessService = inject(AccessService);
    private router = inject(Router);
    private fb = inject(UntypedFormBuilder);
    private dataService = inject(DataService);
    private route = inject(ActivatedRoute);
    private toastrService = inject(ToastrService);

    ViewMode = ViewMode;

    form!: UntypedFormGroup;
    id_supplier!: string;
    viewMode!: ViewMode;
    supplier: any;

    ngOnInit(): void {
        this.id_supplier = this.route.snapshot.paramMap.get('id') ?? '0';
        this.viewMode = this.id_supplier == '0' ? ViewMode.INSERT : ViewMode.VIEW;

        this.form = this.fb.group({
            id: [null],
            name: [null, Validators.required],
            zip: [null, Validators.required],
            city: [null, Validators.required],
            street: [null, Validators.required],
            name_masterdata: [null, Validators.required],
            email_masterdata: [null, Validators.required],
            name_order: [null, Validators.required],
            email_order: [null, Validators.required],
            register_number: [null, Validators.required],
            vat_number: [null, Validators.required],
            iban: [null, Validators.required],
            bic: [null, Validators.required],
            special_text: [null],
            api: [null, Validators.required],
            active: [true],
            order_show_prices: [true],
            order_allow_time: [true],
        });

        if (this.id_supplier !== '0') {
            this.getSupplier();
        }
    }

    getSupplier(): void {
        this.dataService.request('Supplier/get', {
            id_supplier: this.id_supplier
        }).subscribe(response => {
            this.supplier = response.supplier;

            this.patchForm();
        });
    }

    patchForm(): void {
        this.form.patchValue({
            id: this.supplier.id,
            name: this.supplier.name,
            zip: this.supplier.zip,
            city: this.supplier.city,
            street: this.supplier.street,
            name_masterdata: this.supplier.name_masterdata,
            email_masterdata: this.supplier.email_masterdata,
            name_order: this.supplier.name_order,
            email_order: this.supplier.email_order,
            register_number: this.supplier.register_number,
            vat_number: this.supplier.vat_number,
            iban: this.supplier.iban,
            bic: this.supplier.bic,
            special_text: this.supplier.special_text,
            api: this.supplier.api,
            active: this.supplier.active == 1,
            order_show_prices: this.supplier.order_show_prices == 1,
            order_allow_time: this.supplier.order_allow_time == 1,
        });
    }

    save(): void {
        this.dataService.request('Supplier/save', {
            supplier: this.form.getRawValue(),
        }).subscribe(() => {
            this.router.navigate(['/supplier']);
            this.toastrService.success('Der Lieferant wurde angelegt');
        });
    }

    update(): void {
        this.dataService.request('Supplier/update', {
            supplier: this.form.getRawValue(),
        }).subscribe(() => {
            this.setMode(ViewMode.VIEW);
            this.getSupplier();
            this.toastrService.success('Der Lieferant wurde aktualisiert');
        });
    }

    cancel(): void {
        this.router.navigate(['/supplier']);
    }

    setMode(viewMode: ViewMode): void {
        this.viewMode = viewMode;
    }

    cancelEdit(): void {
        this.patchForm();
        this.setMode(ViewMode.VIEW);
        this.getSupplier();
    }

    delete(): void {
        Swal.fire({
            title: 'Sicher?',
            text: 'Der Lieferant wird gelöscht.',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#DD6B55',
            confirmButtonText: 'Ja',
            cancelButtonText: 'Nein'
        }).then(result => {
            if (result.value) {
                this.dataService.request('Supplier/delete', {
                    id_supplier: this.id_supplier
                }).subscribe(() => {
                    this.cancel();
                    this.toastrService.success('Der Lieferant wurde gelöscht');
                });
            }
        });
    }
}
